document.addEventListener('DOMContentLoaded', function () {
  let header = document.querySelector('header[data-sticky=false]');
  let prevScrollPos = window.pageYOffset;

  window.addEventListener('scroll', () => {
    let clientWidth = window.innerWidth > 992 ? 45 : 100;

    if (header) {
      window.pageYOffset > 500 ? header.classList.add('shadow') : header.classList.remove('shadow');

      let currentScrollPos = window.pageYOffset;

      if (currentScrollPos > 150) {
        prevScrollPos > currentScrollPos ? header.style.top = '0' : header.style.top = `-${clientWidth}px`;
        prevScrollPos = currentScrollPos;
      }
    }
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/animate_header.js